<template>
    <div class="flex flex-col gap-6 items-center max-h-150 overflow-auto">
        <div class="w-12 h-12 md:w-16 md:h-16 hidden md:block">
            <CoachingModeMarble />
        </div>
        <h1 class="display-serif hidden md:inline">Here's a Recap</h1>
        <ChatInsightAccordion v-for="insight in insights" :key="`${insight.message.chat_message_id}-${insight.lineIdx}`" class="w-full md:max-w-80" :data="insight.line" />
        <BaseAccordion v-if="profileInferences.length > 0" :accordion-ids="[accordionId]" class="accordion w-full md:max-w-90">
            <template #expandIcon><span class="shrink-0 font-semibold text-valence-primary-500">View</span></template>
            <template #collapseIcon><span class="shrink-0 font-semibold text-valence-primary-500">Close</span></template>
            <template #[makeTriggerSlot(accordionId)]>
                <div class="flex items-center">
                    <BaseAvatar v-if="userName" size="md" theme="primary" :initials="getFirstLastInitials(userName)" class="relative -left-2" translate="no" />
                    <span class="font-semibold text-left leading-[normal]">{{ profileInferences.length }} Memories saved to profile</span>
                </div>
            </template>
            <template #[makeContentSlot(accordionId)]>
                <div class="p-4 overflow-y-auto max-h-60">
                    <ChatActionProfileInferences :inferences="profileInferences" hide-forget-button />
                </div>
            </template>
        </BaseAccordion>
    </div>
</template>

<script setup lang="ts">
import ChatActionProfileInferences from "~vue/ChatActionProfileInferences.vue";
import type { ChatAction, PluckedAction } from "~vue/chatActions";
import ChatInsightAccordion from "~vue/ChatWidgets/ChatInsightAccordion.vue";
import { makeContentSlot, makeTriggerSlot } from "~vue/ChatWidgets/ChatWidgetAccordion.vue";
import BaseAccordion from "~vue/components/BaseAccordion.vue";
import BaseAvatar from "~vue/components/BaseAvatar.vue";
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import type { UserProfileData } from "~vue/types/profile";
import { getFirstLastInitials } from "~vue/utils/stringUtils";

type ChatRecapProps = {
    insights: PluckedAction<ChatAction.VALUES_INSIGHT | ChatAction.INTERNAL_THINKING>[];
    profileInferences: UserProfileData[];
    userName?: string;
};

defineProps<ChatRecapProps>();

const accordionId = "memories";
</script>

<style scoped>
@reference "../../../css/tailwind.css";
.accordion {
    @apply rounded-full border-2 border-border;

    :deep() {
        & .trigger {
            @apply md:min-w-[360px] px-4 rounded-4xl;

            &[data-state="open"] {
                @apply rounded-bl-none rounded-br-none;
            }
        }
        & .item {
            @apply rounded-4xl;
        }
    }
}
</style>
